import { Dropdown } from '@agro1desenvolvimento/react-components';
import { TetrazolioHookData } from '../../../hooks/useTetrazolio';
import { CanteiroAreiaHookData } from '../../../hooks/useCanteiroAreia';
import { orderOptions } from '../../../hooks/useTetrazolioOrder';

interface Props {
  data: TetrazolioHookData | CanteiroAreiaHookData;
}

export default function ListaSementesHeader({ data }: Props) {
  const { selectedOrder, changeOrder } = data;

  return (
    <div className="lista-sementes-header">
      <h4>Amostras</h4>

      <div className="dropdown-field">
        <label>Ordenar por</label>
        <Dropdown
          value={selectedOrder.value}
          options={orderOptions}
          onChange={(e) => changeOrder(e.value)}
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione..."
        />
      </div>

    </div>
  );
}
